import { render, staticRenderFns } from "./DivisionUsers.vue?vue&type=template&id=5db18f84"
import script from "./DivisionUsers.vue?vue&type=script&lang=js"
export * from "./DivisionUsers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports